module.exports = __webpack_public_path__ + "img/enugu.fa333ef2.png";